





























































import { Component, Vue } from 'vue-property-decorator';
import { LoginCredentials } from '../interfaces/loginCredentials';
import { Action } from 'vuex-class';
import AppMessage from 'modules/core/models/appMessage';
import { ApiResponse } from '../interfaces/apiResponse';
import { ElForm } from 'element-ui/types/form';
import { SelectOptions } from 'modules/core/interfaces/selectOptions';
import { RegisterFormInterface } from '../interfaces/registerForm';
import PhoneInput from 'modules/core/components/forms/PhoneInput.vue';
import i18n from '@/i18n/index';
import { AppResponse } from 'modules/core/interfaces/appResponse';

@Component({
  components: {
    PhoneInput,
  },
})
export default class Login extends Vue {
  public form: RegisterFormInterface = {
    Email: '',
    PhoneNumber: '',
    Password: '',
    ConfirmPassword: '',
    MarketingConsent: false,
    NewsletterConsent: false,
  };
  public formValidationRules!: any;
  public phoneModel = {
    phone: '',
    code: undefined,
  };
  public termsAccepted: boolean = false;
  public loading: boolean = false;

  @Action('auth/login') private login!: (
    data: LoginCredentials,
  ) => Promise<ApiResponse>;

  @Action('auth/register') private register!: (
    data: RegisterFormInterface,
  ) => Promise<boolean | undefined>;

  public created() {
    this.formValidationRules = {
      Email: [
        { type: 'email', required: true, message: this.$t('forms.invalidEmail'), trigger: 'blur' },
      ],
      Password: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
            if (strongRegex.test(value)) {
              callback();
            } else {
              callback(new Error(this.$t('forms.passwordPolicy') as string));
            }
          },
        },
      ],
      ConfirmPassword: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if (value !== '' && value === this.form.Password) {
              callback();
            } else {
              callback(new Error(this.$t('forms.passwordsNotMatch') as string));
            }
          },
        },
      ],
      PhoneNumber: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if ((this.$refs.phoneInput as PhoneInput).validate()) {
              callback();
            } else {
              callback(new Error(this.$t('forms.wrongPhone') as string));
            }
          },
        },
      ],
      termsAccepted: [
        { trigger: 'change',
          validator: (rule: any, value: boolean, callback: (error?: Error) => void) => {
            if (this.termsAccepted) {
              callback();
            } else {
              callback(new Error(this.$t('forms.acceptTerms') as string));
            }
          },
        },
      ],
    };
  }

  public updatePhoneNumber(val: any) {
    this.form.PhoneNumber = val.code + val.phone;
    this.phoneModel = val;
  }

  public onSubmit() {
    try {
      this.loading = true;

      (this.$refs.registerForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          try {
            const registered = await this.register(this.form);
            if (registered) {
              const loginResponse = await this.login({
                username: this.form.Email,
                password: this.form.Password,
              });

              if (loginResponse.status === 200) {
                if (loginResponse.data && loginResponse.data.status) {
                  this.$router.push('/');
                } else {
                  this.$router.push('/login');
                }
              } else {
                this.$router.push('/login');
              }
            } else {
              AppMessage.show(
                'Error during registration process, please try again',
                'error',
              );
              this.loading = false;
            }
          } catch (error) {
            console.warn('error', error);
            this.ShowErrors(error);
            this.loading = false;
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    } catch (error) {
      this.loading = false;
      console.warn('Error during registration process: ' + error);
      AppMessage.show('Error during registration process: ' + error, 'error');
    }
  }

  private ShowErrors(error: any) {
    if (error.response && error.response.data) {
      const appResponse: AppResponse<any> = error.response.data;
      const errorMsgs = [];

      for (const errorCode of appResponse.ErrorCodes) {
        errorMsgs.push(i18n.t(`backend.errors.${errorCode}`));
      }

      AppMessage.show(errorMsgs.join('<br>'), 'error');
    }
  }
}
